import { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

import { MENU } from "../../../constants/menu";
import { AuthContext } from "../../../context/AuthProvider";
import { useBoardItem } from "../../../hooks/useBoardItem";
import {
  checkRoleAndPermissions,
  getPermissionMessage,
} from "../../../components/CheckRoleAndPermission";
import {
  BOARD_PERMISSION,
  NON_MEMBER_PERMISSIONS,
} from "../../../constants/permission";

const MainHeader = ({ setOpenSidebar }) => {
  const location = useLocation();
  const { isAuthenticated, isAdmin, setProfile, roleCode } =
    useContext(AuthContext);
  const navigate = useNavigate();
  const { boards } = useBoardItem();

  const isHomePage = location.pathname === "/" || location.pathname === "/Home";

  const [isScrolling, setIsScrolling] = useState(false);

  const needAuthenticated = (e, menu) => {
    if (menu.to.includes("/Research") && !isAuthenticated) {
      alert("연구자 로그인 후 사용하실 수 있습니다.");
      e.preventDefault();
    } else if (
      menu?.boardCode &&
      !checkRoleAndPermissions(
        roleCode,
        boards[menu.boardCode],
        BOARD_PERMISSION.ACCESS,
        NON_MEMBER_PERMISSIONS[menu.boardCode],
        isAdmin
      )
    ) {
      alert(getPermissionMessage(BOARD_PERMISSION.ACCESS));
      e.preventDefault();
    }
  };

  const onLogout = () => {
    setProfile({});
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userId");
    localStorage.removeItem("refreshToken");

    navigate("/");
  };

  useEffect(() => {
    if (!isHomePage || !window) return;

    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolling(true);
      } else {
        setIsScrolling(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      window?.removeEventListener("scroll", handleScroll);
    };
  }, [isHomePage]);

  return (
    <div className="all_wrap">
      <nav
        className={`lg:h-[100px] h-[60px] flex items-center top-0 fixed w-full left-0 z-[100] ${
          !isHomePage ? "border-b border-gray-border" : ""
        }`}
        style={{
          background: !isHomePage
            ? "white"
            : isScrolling
            ? "#ffcce4"
            : "linear-gradient(180deg, rgba(244, 83, 163, 0.20) 0%, rgba(244, 83, 163, 0.00) 100%)",
          transition: `0.3s all`,
        }}
      >
        <div className="width flex items-center justify-between">
          <Link className="flex items-center gap-4" to="/">
            <img
              src={
                isHomePage ? "/assets/img/wlogo.png" : "/assets/img/clogo.png"
              }
              alt="main logo"
              className="2xl:w-[213px] xl:w-[170px] w-[130px] h-auto hidden lg:block"
            />
            <img
              src="/assets/img/clogo.png"
              alt="main logo"
              className="w-[130px] h-auto lg:hidden"
            />
          </Link>

          <ul className="hidden lg:flex items-center">
            {MENU.map((item) => (
              <li
                key={item.id}
                className="2xl:py-6 2xl:px-9 p-5 relative menu-item"
              >
                <Link
                  onClick={(e) => needAuthenticated(e, item)}
                  className={`2xl:text-lg xl:text-base text-sm ${
                    isHomePage ? "font-semibold text-white" : "font-medium"
                  }`}
                  style={{
                    textShadow: isHomePage ? "0px 0px 2px #F154A5" : "none",
                  }}
                  to={item.to}
                >
                  {item.title}
                </Link>

                {item?.items?.length > 0 && (
                  <ul
                    className="sub-menu w-[200px] rounded z-[100] bg-white text-center"
                    style={{
                      boxShadow: "0px 0px 10px rgba(0,0,0,0.12)",
                    }}
                  >
                    {item.items.map((c) => (
                      <li key={c.id}>
                        <Link
                          className="block text-center py-[10px] 2xl:text-[15px] text-sm font-medium text-[#333] hover:text-primary"
                          onClick={(e) => needAuthenticated(e, c)}
                          to={c.to}
                        >
                          {c.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>

          <div className="bg-primary lg:flex hidden items-center justify-center rounded 2xl:h-[50px] h-[45px] text-white">
            {isAuthenticated ? (
              <>
                <Link
                  to="/MyPage"
                  className="2xl:h-[50px] h-[45px] px-3 flex items-center gap-1 2xl:text-lg xl:text-base text-sm"
                >
                  <img src="/assets/img/toplogin1.png" alt="" />
                  MyPage
                </Link>
                <div className="w-[1px] h-3 bg-white" />
                {isAdmin && (
                  <>
                    <a
                      href={`/admin`}
                      target="_blank"
                      className="2xl:h-[50px] h-[45px] px-3 flex items-center gap-1 2xl:text-lg xl:text-base text-sm"
                      rel="noreferrer"
                    >
                      Admin
                    </a>
                    <div className="w-[1px] h-3 bg-white" />
                  </>
                )}
                <button
                  className="2xl:h-[50px] h-[45px] px-3 flex items-center gap-1 2xl:text-lg xl:text-base text-sm"
                  onClick={onLogout}
                >
                  <img src="/assets/img/toplogin2.png" alt="" />
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/Login"
                  className="2xl:h-[50px] h-[45px] px-3 flex items-center gap-1 2xl:text-lg xl:text-base text-sm"
                >
                  <img src="/assets/img/toplogin1.png" alt="" />
                  Login
                </Link>
                <div className="w-[1px] h-3 bg-white" />
                <Link
                  to="/Register"
                  className="2xl:h-[50px] h-[45px] px-3 flex items-center gap-1 2xl:text-lg xl:text-base text-sm"
                >
                  Sign Up
                </Link>
              </>
            )}
          </div>

          <button
            className="h-8 w-8 lg:hidden flex items-center justify-center"
            onClick={() => setOpenSidebar(true)}
          >
            <FontAwesomeIcon icon={faBars} size="xl" />
          </button>
        </div>
      </nav>
    </div>
  );
};

export default MainHeader;
